import React from 'react'
import { InsightCardContent, InsightCardWrapper } from 'src/components/insights/common/cards/card'
import { InsightCardLoadingBoundary } from 'src/components/insights/common/cards/card-loading-boundary'

type InsightCardSimpleProps = {
  className?: string
  children?: React.ReactNode
  errorTitle?: string
  errorMsg?: string
  noPadding?: boolean
}

export const InsightCardSimple: React.FC<InsightCardSimpleProps> = (props) => {
  const { children, className, noPadding, errorTitle, errorMsg } = props

  return (
    <InsightCardWrapper className={className}>
      <InsightCardContent noPadding={noPadding}>
        <InsightCardLoadingBoundary title={errorTitle} message={errorMsg}>
          {children}
        </InsightCardLoadingBoundary>
      </InsightCardContent>
    </InsightCardWrapper>
  )
}
